/** Colyseus accepts http(s) URL; it negotiates WebSocket. */
export function getColyseusEndpoint(): string {
  const env = import.meta.env.VITE_COLYSEUS_ENDPOINT;
  if (env) return env.replace(/\/$/, "");
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    return `http://${host}:2567`;
  }
  return "http://127.0.0.1:2567";
}
